"use client";

import React from "react";
import { Zap, Settings, CalendarSync, MapPin } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicePillars = [{
  id: "delivery-dakar",
  title: "Livraison Dakar 24h",
  description: "Service express quotidien sur tout Dakar et les Almadies pour vos capsules Dolce Gusto et Tassimo.",
  icon: "zap"
}, {
  id: "delivery-regions",
  title: "Thiès & Petite Côte",
  description: "Tournées hebdomadaires régulières à Thiès, Mbour et Saly pour garantir votre approvisionnement.",
  icon: "calendar"
}, {
  id: "setup-pro",
  title: "Installation & Support",
  description: "Mise en service professionnelle de vos machines et maintenance technique pour les entreprises.",
  icon: "settings"
}];
export default function DakarThiesExpress() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: areCardsVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="153598" id="zone-de-livraison" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32" ref={sectionRef}>
      {}
      <div className="pointer-events-none absolute top-0 left-0 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/5 blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-[600px] w-[600px] translate-x-1/3 translate-y-1/3 rounded-full bg-accent/10 blur-[150px]" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-16 lg:grid-cols-2 lg:items-center">
          
          {}
          <div className={`flex flex-col gap-8 transition-all duration-1000 ${isSectionVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-secondary px-4 py-1.5 text-sm font-medium text-primary backdrop-blur-sm">
                <MapPin className="size-4" />
                <span>Zone de Service</span>
              </div>
              <h2 className="font-serif text-4xl font-bold leading-tight tracking-tight md:text-5xl lg:text-6xl">
                Livraison rapide à <span className="text-primary">Dakar</span>, <span className="text-primary">Thiès</span> et sur la <span className="text-primary">Petite Côte</span>.
              </h2>
              <p className="max-w-xl text-lg text-muted-foreground font-sans">
                KBC Coffee Service assure la distribution de vos capsules et machines directement dans vos locaux. Notre réseau logistique dédié garantit une disponibilité constante pour vos moments café.
              </p>
            </div>

            <div className="relative mt-4 overflow-hidden rounded-2xl border border-border/50 bg-card/30 p-4 backdrop-blur-sm">
              <div className="absolute inset-0 bg-gradient-to-tr from-background/80 via-transparent to-transparent z-10" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592750/img/dakar_thies_corridor_gold_vector_map.png" alt="Carte stylisée de la zone de livraison KBC Coffee Service au Sénégal" className="relative z-0 w-full object-cover opacity-90 mix-blend-multiply transition-transform duration-700 hover:scale-105" />
            </div>
          </div>

          {}
          <div ref={cardsRef} className="flex flex-col gap-6">
            {servicePillars.map((pillar, i) => <div key={pillar.id} data-index={i} className={`transition-all duration-700 delay-${i * 200}`} style={{
            opacity: areCardsVisible ? 1 : 0,
            transform: areCardsVisible ? 'translateY(0)' : 'translateY(30px)'
          }}>
                <Card className="group relative overflow-hidden border-border/40 bg-card/40 backdrop-blur-xl transition-all hover:bg-card/60 hover:shadow-xl hover:shadow-primary/5">
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
                  <CardHeader className="relative z-10 flex flex-row items-center gap-4 pb-2">
                    <div className="flex size-12 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary ring-1 ring-primary/20 transition-transform group-hover:scale-110 group-hover:bg-primary/20">
                      {pillar.icon === "zap" && <Zap className="size-6" />}
                      {pillar.icon === "settings" && <Settings className="size-6" />}
                      {pillar.icon === "calendar" && <CalendarSync className="size-6" />}
                    </div>
                    <CardTitle className="text-xl font-serif font-semibold tracking-tight text-card-foreground">
                      {pillar.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="relative z-10 pt-2">
                    <CardDescription className="text-base text-muted-foreground font-sans">
                      {pillar.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>)}

            <div className={`mt-6 transition-all duration-1000 delay-700 ${areCardsVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <Button size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 font-semibold tracking-wide rounded-xl shadow-lg">
                Commander via WhatsApp
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}